module.exports = __webpack_public_path__ + "img/floorFour.7f12d7c0.png";